import { Box, Button, Dialog, DialogContent, DialogTitle, Stack, Grid, TextField } from "@mui/material"
import LabelPrinter from "../../../../../../../../components/LabelPrinter"
import { formatarInputValorMonetário, formatarMonetárioParaNúmero, formatarValorMonetario } from "../../../../../../../../helpers/masks"
import { useState } from "react"
import { ContaContabil } from "../../../../../../../../types/api/geral/pesquisar-plano-contas"
import { useFormContext } from "react-hook-form"
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import SelectPlanoContas from "../../../../../../../../components/SelectsSimpleApiQuery/SelectPlanoContas"
import AddIcon from '@mui/icons-material/Add';
import { enqueueSnackbar } from "notistack"

export default function DialogAdicionar({
    open,
    handleClose
}: DialogAdicionarProps) {

    const { getValues, setValue } = useFormContext()
    const prevRateios = getValues("step03.rateios")
    const valorLancamentos = getValues("step02.valor")

    const [valores, setValores] = useState<ValoresRateio[]>(
        prevRateios.length === 0 ? [{ contaDevedora: null, valor: "" }] : prevRateios
    )

    //funcoes manipuladoras
    const handleAddLinha = () => {
        setValores([...valores, { contaDevedora: null, valor: "" }])
    }

    const handleRemoveLinha = (index: number) => {
        const novasLinhas = valores.filter((_, idx) => idx !== index)
        setValores(novasLinhas)
    }

    const handleChangeContaDevedora = (index: number, value: ContaContabil | null) => {
        const novasLinhas = [...valores]
        novasLinhas[index].contaDevedora = value
        setValores(novasLinhas)
    }

    const handleChangeValorRateio = (index: number, value: string) => {
        const novasLinhas = [...valores]
        novasLinhas[index].valor = value
        setValores(novasLinhas)
    }

    const handleSubmit = () => {
        const temContaDevedoraNula = valores.some(item => item.contaDevedora === null)

        if (temContaDevedoraNula) {
            enqueueSnackbar("Todas as contas devedoras devem ser preenchidas", { variant: "error" })
            return
        }

        const temValorInvalido = valores.some(item => {
            const valor = formatarMonetárioParaNúmero(item.valor)
            return !valor || valor <= 0
        })

        if (temValorInvalido) {
            enqueueSnackbar("Todos os valores devem ser preenchidos e maiores que zero", { variant: "error" })
            return
        }

        setValue('step03.rateios', valores)
        handleClose()
    }
    //

    //valores importantes
    const totalRateio = valores.reduce((acc, curr) => acc + (formatarMonetárioParaNúmero(curr.valor) || 0), 0)
    //

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                Rateio
            </DialogTitle>

            <DialogContent>
                <Box mt={1}>
                    {valores.map((linha, index) => (
                        <Grid container spacing={2} key={index} alignItems="center" mb={2}>
                            <Grid size={{xs: 7}}>
                                <SelectPlanoContas
                                    inputLabel="Conta devedora"
                                    required
                                    value={linha.contaDevedora}
                                    onChangeValue={(valor) => handleChangeContaDevedora(index, valor as ContaContabil)}
                                    extraParams={{ tipo: "Analítica" }}
                                />
                            </Grid>

                            <Grid size={{xs: 3.5}}>
                                <TextField
                                    fullWidth
                                    label="Valor"
                                    value={linha.valor}
                                    onChange={(e) => handleChangeValorRateio(index, formatarInputValorMonetário(e.target.value))}
                                />
                            </Grid>

                            <Grid size={{xs: 0.5}}>
                                {valores.length > 1 && index !== valores.length - 1 ? (
                                    <Button
                                        color="error"
                                        variant="text"
                                        onClick={() => handleRemoveLinha(index)}
                                        sx={{ height: '56px' }}
                                    ><DeleteOutlineIcon /></Button>
                                ) : index === valores.length - 1 && (
                                    <Button
                                        variant="text"
                                        onClick={handleAddLinha}
                                        sx={{ height: '56px' }}
                                    ><AddIcon /></Button>
                                )}
                            </Grid>
                        </Grid>
                    ))}
                </Box>
            </DialogContent>

            <Stack p={3} direction="row" justifyContent="space-between" alignItems="flex-end">
                <Stack direction={"row"} spacing={3}>
                    <LabelPrinter
                        size="small"
                        valor={valorLancamentos}
                        titulo="Valor do lançamento"
                    />
                    <LabelPrinter
                        size="small"
                        titulo="Total rateio"
                        valor={formatarValorMonetario(totalRateio)}
                        color={valorLancamentos === formatarValorMonetario(totalRateio) ? 'primary' : 'error'}
                    />
                </Stack>

                <Stack direction="row" spacing={1}>
                    <Button onClick={handleClose}>
                        Cancelar
                    </Button>
                    <Button
                        autoFocus
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={valorLancamentos !== formatarValorMonetario(totalRateio)}
                    >
                        Salvar
                    </Button>
                </Stack>
            </Stack>
        </Dialog>
    )
}

interface DialogAdicionarProps {
    open: boolean,
    handleClose: () => void
}

export type ValoresRateio = {
    contaDevedora: ContaContabil | null,
    valor: string
}
